import { Gender_Association } from '@acme/db';

export function getGenderAssociation(_genderAssociation: string | undefined) {
  const genderAssociation = _genderAssociation?.toLowerCase();
  if (!genderAssociation) return undefined;
  if (genderAssociation === 'female' || genderAssociation === 'woman') return Gender_Association.female;
  if (genderAssociation === 'male' || genderAssociation === 'man') return Gender_Association.male;
  return Gender_Association.gender_neutral;
}